

























import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";
import { Key } from "@/../generated/iloq-api";
import SearchInput from "@/components/common/SearchInput.vue";

@Component({
  components: { SearchInput }
})
export default class Keys extends Vue {
  searchInput = "";

  get keys(): Key[] {
    return lockModule.keys.filter(
      key =>
        key.Description?.toLowerCase().includes(
          this.searchString.toLowerCase()
        ) ||
        key.InfoText?.toLowerCase().includes(this.searchString.toLowerCase())
    );
  }

  get searchString(): string {
    return this.searchInput.toLowerCase();
  }

  mounted() {
    this.fetchKeys();
  }

  fetchKeys() {
    lockModule.fetchKeys();
  }
}
